import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

/**
 * The article account of a return run's project: what went out, what has come back, what is still
 * on site.
 *
 * `"return-order"` leads the key so a booking invalidating that segment refreshes the figures —
 * the whole point of the screen is that the outstanding column moves as material is booked.
 */
export function useReturnReconciliation(returnOrderId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["return-order", guardString(returnOrderId), "reconciliation"],
		queryFn: async () => {
			const response = await client.stock["return-orders"][":returnOrderId"].reconciliation.$get({
				param: { returnOrderId: guardString(returnOrderId) },
			});
			const data = await responseHandler(response, false);
			return data.reconciliation;
		},
		enabled: !!returnOrderId,
	});

	/** Return */
	return { ...query, reconciliation: query.data };
}
